import type { PageContext } from 'vike/types';
import type { Language } from '@/types/locales';
import { LOCALES } from '@/types/locales';

const extractLocale = (url: string) => {
    const path = url.split('/');

    const first = path[1] as Language;
    if (LOCALES.includes(first)) {
        return {
            locale: first,
            urlPathnameWithoutLocale: `/${path.slice(2).join('/')}`
        };
    }

    return {
        locale: null,
        urlPathnameWithoutLocale: url
    };
};

export const onBeforeRoute = (pageContext: PageContext) => {
    const { urlPathnameWithoutLocale, locale } = extractLocale(pageContext.urlParsed.pathname);

    return {
        pageContext: {
            locale,
            urlLogical: urlPathnameWithoutLocale,
            truePath: urlPathnameWithoutLocale
        }
    };
};
